<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2h5yPO/tc-custom/9781035836376.jpg?1725565493912" alt="This image is the cover for the book Irish Fireworks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Irish Fireworks
      </h1>
      <p class="bookDescription body article font2">
        <p>As a firefighter, confronting life and death scenarios is a daily reality. Trained to tackle the perils of fire from various perspectives, these brave individuals often encounter situations far more intense than the typical house fire, demanding not only courage but also quick thinking and ingenuity. The O’Briens, a family of dedicated firefighters from Chicago, are well-versed in the risks of their profession. They embrace these hazards as part of their commitment to serving their community. However, beyond the flames, they sometimes find themselves entangled in unexpected predicaments, requiring them to adapt and tackle danger from new angles. Despite the challenges, they’ve consistently emerged from these ordeals a little scorched but always ready to respond to the next emergency. Yet, it’s in the realm of personal relationships where the O’Briens encounter their greatest challenges. Matters of the heart prove to be the most perilous for this family of firefighters, testing their resilience and bravery in ways they never anticipated.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cat Walker
      </h2>
      
      <p class="authorDescription body article">Cat Walker was born and raised in Minnesota, USA, where she first developed her love of creative writing. In 2006, she visited Ireland and fell in love, literally. She moved to Ireland in January 2007, and now lives in County Meath with her Ireland-born husband, and spends her time expanding her imagination and enjoying the beautiful Irish countryside.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fa4c966